import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=15c1a4bb&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15c1a4bb')) {
      api.createRecord('15c1a4bb', component.options)
    } else {
      api.reload('15c1a4bb', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=15c1a4bb&", function () {
      api.rerender('15c1a4bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2F7aqFCH97vr7/JS/imageCarousel.vue"
export default component.exports